import React from "react";
import styles from "./ContactBanner.module.scss";
import RequestBtn from "../../assets/img/facility/facility-request-btn.webp";
import RequestBtnHover from "../../assets/img/facility/facility-request-btn-hover.webp";
import { sendEventTracking } from "../../utils/GeneralUtils";
import SonicLink from "../../common/routing/SonicLink";

const ContactBanner: React.FC = () => {
  return (
    <SonicLink
      to="/contact"
      className={styles["contact-banner-link"]}
      onClick={() =>
        sendEventTracking("click", "FacilityRequest", "施設リクエストバナー")
      }
    >
      <picture>
        <img
          src={RequestBtn}
          alt="eスポーツ施設情報の掲載依頼お待ちしています"
        />
        <img
          src={RequestBtnHover}
          alt="eスポーツ施設情報の掲載依頼お待ちしています"
        />
      </picture>
    </SonicLink>
  );
};

export default ContactBanner;
